import React, {Component} from 'react'
import {Spinner} from 'react-redux-spinner'
import Header from './components/header'
import './App.css'

class App extends Component {
  render() {
    return (
      <div className="App">
        <Spinner />
        <br />
        <Header />
        {this.props.children}
      </div>
    )
  }
}

export default App



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/